import RoutingPage from "./bodyComponent/RoutingPage";
import App from "./App";
import Summary from "./bodyComponent/Summary";
import SelfIntroduction from "./bodyComponent/Summary/selfIntroduction";
import Projects from "./bodyComponent/Summary/projects";
import Others from "./bodyComponent/Summary/others";
import AllSummary from "./bodyComponent/Summary/allSummary";

const routes = [
    {
        path: '/',
        element: <App/>,
    },
    {
        path: '/',
        element: <Summary/>,
    },
    {
        path: '/self-introduction',
        element: <SelfIntroduction/>,
    },
    {
        path: '/projects',
        element: <Projects/>,
    },
    {
        path: '/others',
        element: <Others/>,
    },
    {
        path: 'all',
        element: <AllSummary/>
    },
    {
        path: '/route-test',
        element: <RoutingPage />,
    }
];

export default routes;